import { IRegVisualization } from './types'
import { DefaultVisualizations, getFlexData, DefaultCompareVisualizations } from './charts-factory'

export class SSOverviewComponent {
 static config = {
  selector: 'ssOverviewComponent',
  controller: SSOverviewComponent,
  bindings: {
   visualizationData: '<',
   registerVisualization: '<',
   onUpdate: '<',
   userTimeZone: '<',
   isLoading: '<',
   isError: '<',
   view: '<',
   visualizationsSplit: '<',
   dateRange: '<',
   treatments: '<',
   isRestricted: '<',
  },
  template: `
      <div class="af__con" layout="row" layout-wrap layout-xs="column">

        <base-widget
          ng-repeat="item in $ctrl.analyticsVisualizations"
          visualization-id="item.id"
          component-template="item.component"
          component-options="item.componentOptions"
          viz-data="$ctrl.visualizationData[item.id]"
          user-time-zone="$ctrl.userTimeZone"
          on-update="$ctrl.onUpdate"
          is-loading="$ctrl.isLoading"
          is-error="$ctrl.isError"
          date-range="$ctrl.dateRange"
          properties="item.properties"
          treatments="$ctrl.treatments"
          has-split="(item.splitId && $ctrl.treatments[item.splitId])? ($ctrl.treatments[item.splitId]==='on'? true : false ): true"
          is-restricted="$ctrl.isRestricted"
          class="af__social__widget"
          ng-attr-flex-sm="{{$ctrl.getFlexDatas($ctrl.view,'sm', item)}}"
          ng-attr-flex-md="{{$ctrl.getFlexDatas($ctrl.view,'md', item)}}"
          ng-attr-flex-lg="{{$ctrl.getFlexDatas($ctrl.view,'lg', item)}}"
          ng-attr-flex-xl="{{$ctrl.getFlexDatas($ctrl.view,'xl', item)}}"
          flex>
        </base-widget>
      </div>
    `,
 }

 // Bindings
 private registerVisualization: any
 private visualizationsSplit: boolean
 private onUpdate: any
 private getFlexDatas: any
 private isError: any
 // Internals
 private analyticsVisualizations: Array<IRegVisualization> = []

 $onInit() {
//   this.analyticsVisualizations = DefaultCompareVisualizations
  this.analyticsVisualizations = DefaultVisualizations

  // register visualization settings
  this.analyticsVisualizations.map(vizConfig => this.registerVisualization(vizConfig))
  this.getFlexDatas = getFlexData
 }
}
